import FormulardatenViewDto from "../form/dto/FormulardatenViewDto";
import BackendService from "../common/BackendService";
import RkResultViewDto from "../rk/dto/RkResultViewDto";
import AppInitSingletonBo from "../init/AppInitSingletonBo";
import BrowserDetection from "../../app/util/BrowserDetection";
import AgentInfoDto from "./AgentInfoDto";

const antragEinreichen = (formDto: FormulardatenViewDto, rkDto: RkResultViewDto) => {
    const agentInfo = BrowserDetection.createUserAgentInfo();
    const agentInfoDto = new AgentInfoDto(agentInfo);

    const params = {};
    const data = {
        formIhrTier: formDto.ihrTier,
        formAntrag: formDto.antrag,
        formAngebot: formDto.angebot,
        rk: rkDto,
        vertragLaufzeitJahre: AppInitSingletonBo.vertragLaufzeitJahre,
        agentInfo: agentInfoDto
    }
    return BackendService.postData('rest/op/antrag/einreichen', params, data)
        .then(root => {
            const vorgnr: string | undefined = root.vorgnr;
            return vorgnr;
        })
        .catch(error => {
            // TODO Fuest logging
            throw error;
        })
}


const AntragConsumer = {
    antragEinreichen
}

export default AntragConsumer;